/* Craftybella - product page trust strip.
   The styled strip lives in cb-pdp-main, which only runs on the custom product
   templates. Most products use the stock template, so the 8% prepaid line and
   the Razorpay reassurance never appeared. This injects the same strip on every
   product page, and corrects the old "CASHFREE" wording - the store settles
   through Razorpay. */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;

  var CSS = '.cb-pay{margin:14px 0 4px;padding:11px 13px;border:1px solid #E5DDD7;border-radius:12px;'
    + 'background:#FBF8F4;font-family:Inter,-apple-system,"Segoe UI",Roboto,sans-serif;color:#321B22}'
    + '.cb-pay__top{display:flex;align-items:center;gap:7px;flex-wrap:wrap}'
    + '.cb-pay__ic{width:15px;height:15px;flex:none;color:#8B4059}'
    + '.cb-pay__t{font-size:13px;font-weight:700;letter-spacing:.01em}'
    + '.cb-pay__s{font-size:11.5px;color:#6D6462}'
    + '.cb-pay__m{display:flex;flex-wrap:wrap;gap:5px;margin-top:8px}'
    + '.cb-pay__m span{font-size:10.5px;font-weight:600;letter-spacing:.02em;color:#6D6462;'
    + 'background:#fff;border:1px solid #E5DDD7;border-radius:99px;padding:3px 9px}'
    + '.cb-pay__p{display:flex;align-items:flex-start;gap:6px;margin-top:9px;padding-top:9px;'
    + 'border-top:1px dashed #E5DDD7;font-size:12px;font-weight:600;line-height:1.4;color:#2E7D52}'
    + '.cb-pay__p svg{width:14px;height:14px;flex:none;margin-top:1px}'
    /* the stock Kalles seal advertises PayPal, Apple Pay and Amazon Pay,
       none of which this checkout offers - the strip above replaces it */
    + '.t4s-pr_trust_seal{display:none!important}'
    /* the customizer's name/message boxes are only 33px tall - under the
       44px a thumb reliably hits, which is why they take several taps */
    + '.tcustomizer__text-field-wrapper{cursor:text}'
    + 'input.tcustomizer__text-field{min-height:44px!important}'
    + 'textarea.tcustomizer__text-field{min-height:84px!important}'
    /* The hardcoded "What Our Customers Say" block presents eight unattributed
       testimonials as genuine Craftybella reviews. One of them reads "Loved the
       purchases done from Fubs" - a competitor's review, lifted. That puts the
       whole block in doubt, so it is hidden until the real ones are moved into
       Judge.me, where they attach to an order and show as verified. The section
       key is the same on every product template; only the template id differs.
       This is a stopgap: the text is still in the page source, so the section
       must be deleted in the theme editor. */
    + '[id$="__custom_liquid_FfqhBi"]{display:none!important}';

  var LOCK = '<svg class="cb-pay__ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">'
    + '<rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>';
  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">'
    + '<path d="M20 6 9 17l-5-5"/></svg>';

  var HTML = '<div class="cb-pay">'
    + '<div class="cb-pay__top">' + LOCK
    + '<span class="cb-pay__t">100% Secure Payments</span>'
    + '<span class="cb-pay__s">Powered by Razorpay</span></div>'
    + '<div class="cb-pay__m"><span>UPI</span><span>Cards</span><span>Net Banking</span>'
    + '<span>Wallets</span><span>COD</span></div>'
    + '<div class="cb-pay__p">' + TICK
    + '<span>Pay online and FLAT 8% comes off automatically</span></div></div>';

  function style() {
    if (document.getElementById('cb-pay-css')) return;
    var s = document.createElement('style');
    s.id = 'cb-pay-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function anchor() {
    var btn = document.querySelector('.t4s-product-form__submit[name="add"]');
    if (btn) {
      var box = btn.closest('.t4s-product-form__buttons') || btn.closest('form') || btn.parentElement;
      if (box && box.offsetParent !== null) return box;
    }
    var f = document.querySelector('form[action*="/cart/add"]');
    return f && f.offsetParent !== null ? f : null;
  }

  function insert() {
    if (document.querySelector('.cb-pay')) return true;
    var a = anchor();
    if (!a) return false;
    style();
    a.insertAdjacentHTML('afterend', HTML);
    return true;
  }

  function wording() {
    document.querySelectorAll('.t4s-tab__content, .t4s-accordion__content, .rte, [class*="shipping"]')
      .forEach(function (el) {
        if (el.getAttribute('data-cb-pay-txt') === '1') return;
        if (!/cashfree/i.test(el.textContent)) return;
        el.setAttribute('data-cb-pay-txt', '1');
        var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
        while ((n = w.nextNode())) {
          if (/cashfree/i.test(n.textContent)) {
            n.textContent = n.textContent.replace(/cashfree/gi, 'Razorpay');
          }
        }
      });
  }

  /* Tapping the padding or the character counter inside the box did nothing,
     because only the input itself takes focus. Make the whole box focus it. */
  function boxes() {
    document.querySelectorAll('.tcustomizer__text-field-wrapper').forEach(function (w) {
      if (w.getAttribute('data-cb-focus') === '1') return;
      var f = w.querySelector('input, textarea');
      if (!f) return;
      w.setAttribute('data-cb-focus', '1');
      w.addEventListener('click', function (ev) {
        if (ev.target === f || f.disabled || f.readOnly) return;
        try {
          f.focus({ preventScroll: true });
          var n = f.value.length;
          if (f.setSelectionRange) f.setSelectionRange(n, n);
        } catch (e) {}
      });
    });
  }

  function run() { try { style(); insert(); wording(); boxes(); } catch (e) {} }

  function boot() {
    run();
    var tries = 0;
    var iv = setInterval(function () {
      run();
      if (++tries > 25) clearInterval(iv);
    }, 400);
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(run, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
